import {useId} from 'react';
import type {ComponentProps} from 'react';
import {createPortal} from 'react-dom';
import {useLocale} from '../wheel/hooks/useLocale';
import {t} from '../wheel/i18n/translator';
import type SourceWildMarket from '../wheel/components/spin-wheel/WildMarketModal';
import MarketDialog from './MarketDialog';
import '../styles/wild-market.css';

// Keep the source wheel and its redemption flow intact; only its market view
// is resolved to this host presentation by the member build.
type Props=ComponentProps<typeof SourceWildMarket>;
const comparable=(value:string)=>value.trim().replace(/\s+/g,' ').toLocaleLowerCase('tr-TR');

export default function WildMarketModal({isOpen,onClose,balance,catalog,onRedeem,isRedeeming}:Props){
 const {lang}=useLocale(),locale=lang==='kmr'?'ku':lang,description=useId();
 const format=(value:number)=>value.toLocaleString(locale);
 if(!isOpen)return null;
 return createPortal(<MarketDialog open={isOpen} title="Wild Market" onClose={onClose} className="wild-market-dialog"
  headerAside={<div className="wild-market-balance" aria-label={t(2452)} aria-live="polite" aria-atomic="true"><span>{t(2452)}</span><strong>{format(Math.max(0,balance))} <small>Wild</small></strong></div>}>
  <div className="wild-market-intro"><h3>{t(2451)}</h3><p id={description}>{t(2529)}</p></div>
  {catalog.length===0?<p className="wild-market-empty">{t(2530)}</p>:<ul className="wild-market-grid" aria-describedby={description}>
   {catalog.map(reward=>{
    const outOfStock=reward.stock!==null&&reward.stock<=0,insufficient=balance<reward.wildCost;
    const state=isRedeeming?t(2533):outOfStock?t(2535):insufficient?t(2534):t(2536);
    const detail=reward.rewardType==='physical'?reward.physicalPrizeNote||t(2531):reward.bonusName;
    const showDescription=reward.description&&comparable(reward.description)!==comparable(reward.label);
    const showDetail=detail&&comparable(detail)!==comparable(reward.label)&&(!showDescription||comparable(detail)!==comparable(reward.description));
    return <li key={reward.id}><article className="wild-market-card">
     {reward.imageUrl&&<img className="wild-market-image" src={reward.imageUrl} alt="" loading="lazy"/>}
     <header><div className="wild-market-card-meta"><span>{reward.rewardType==='physical'?t(2531):'Wild ödülü'}</span>{reward.stock!==null&&<span className={'wild-market-stock'+(outOfStock?' empty':'')}>{t(2532,{values:{stock:format(reward.stock)}})}</span>}</div><h3>{reward.label}</h3></header>
     <div className="wild-market-card-copy">{showDescription&&<p>{reward.description}</p>}{showDetail&&<p>{detail}</p>}</div>
     <footer><progress aria-label={reward.label} value={Math.min(Math.max(0,balance),reward.wildCost)} max={Math.max(1,reward.wildCost)}/>
      <button type="button" className="market-button wild-market-redeem" disabled={isRedeeming||insufficient||outOfStock} onClick={()=>onRedeem(reward.id)}><span>{state}</span><strong>{format(reward.wildCost)} Wild</strong></button>
     </footer>
    </article></li>;
   })}
  </ul>}
 </MarketDialog>,document.body);
}
